import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {FacilityType, FacilityTypeData} from "types/FacilityType";
import deserializeFacilityType from "services/ngage/deserializers/facility-type";

/**
 * Get all facility types (paginated)
 */
const all = async (page: number = 1) => {
    const response = await client.get<DataPage<FacilityType> | null>(`/facility-types?page=${page}`)

    if(response.data){
        response.data.data = response.data.data.map(deserializeFacilityType)
    }

    return response.data
}

/**
 * Get a single facility type
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<FacilityType>(`/facility-types/${id}`)
    return response.data? deserializeFacilityType(response.data) : null
}

/**
 * Store a new facility type
 *
 * @param data
 */
const store = async (data: FacilityTypeData) => {
    const response = await client.post<FacilityType>('/facility-types', data)
    return response.data? deserializeFacilityType(response.data) : null
}

/**
 * Update an existing facility type
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: FacilityTypeData) => {
    const response = await client.put<FacilityType>(`/facility-types/${id}`, data)
    return response.data? deserializeFacilityType(response.data) : null
}

/**
 * Permanently delete an facility type
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/facility-types/${id}`)
    return response.status === 204
}

const facilityTypes = {
    all,
    get,
    store,
    update,
    destroy
}

export default facilityTypes;